import { render, staticRenderFns } from "./SuccessMessageHandler.vue?vue&type=template&id=14b46958&scoped=true&"
import script from "./SuccessMessageHandler.vue?vue&type=script&lang=js&"
export * from "./SuccessMessageHandler.vue?vue&type=script&lang=js&"
import style0 from "./SuccessMessageHandler.vue?vue&type=style&index=0&id=14b46958&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b46958",
  null
  
)

export default component.exports